'use strict';

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

Object.defineProperty(exports, '__esModule', {
    value: true
});

var ResponseWrapper = (function () {
    function ResponseWrapper(response, error) {
        _classCallCheck(this, ResponseWrapper);

        this.response = response || {};
        this._error = error;
    }

    _createClass(ResponseWrapper, [{
        key: 'hasError',
        get: function get() {
            return !!this._error;
        }
    }, {
        key: 'error',
        get: function get() {
            return this._error;
        }
    }, {
        key: 'status',
        get: function get() {
            throw new Error('Not implemented');
        }
    }, {
        key: 'statusType',
        get: function get() {
            throw new Error('Not implemented');
        }
    }, {
        key: 'text',
        get: function get() {
            throw new Error('Not implemented');
        }
    }, {
        key: 'body',
        get: function get() {
            throw new Error('Not implemented');
        }
    }]);

    return ResponseWrapper;
})();

exports.ResponseWrapper = ResponseWrapper;
exports['default'] = ResponseWrapper;


/*****************
 ** WEBPACK FOOTER
 ** ./~/tg-resources/dist/response.js
 ** module id = 504
 ** module chunks = 1
 **/